import script from "./Observe.vue?vue&type=script&lang=js"
export * from "./Observe.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__